import opositeNumber from './opositeNumber'

const dateISOtoLocal = (dateISO: string): Date => {
  const date = new Date(dateISO)
  date.setTime(date.getTime() + opositeNumber(date.getTimezoneOffset() * 60 * 1000))
  return date
}

export default dateISOtoLocal
